import React from 'react';
import { Input } from '../../../components/common/Form';

export interface BrandContactData {
  firstName: string;
  lastName: string;
  title: string;
  phone: string;
  email: string;
}

interface BrandContactStepProps {
  data: BrandContactData;
  onChange: (data: BrandContactData) => void;
  onSubmit: () => void;
  onBack: () => void;
}

const INPUT_OVERRIDE = `
  .brand-wizard-form input {
    padding: 10px 12px !important;
    font-size: 0.8125rem !important;
    height: 40px !important;
    box-sizing: border-box !important;
  }
`;

const BrandContactStep = ({ data, onChange, onSubmit, onBack }: BrandContactStepProps) => {
  const updateField = (field: keyof BrandContactData, value: string) => {
    onChange({ ...data, [field]: value });
  };

  return (
    <div className="brand-wizard-form" style={{ width: '100%' }}>
      <style>{INPUT_OVERRIDE}</style>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '32px' }}>
        <Input
          name="firstName"
          label="FIRST NAME"
          value={data.firstName}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateField('firstName', e.target.value)}
        />
        <Input
          name="lastName"
          label="LAST NAME"
          value={data.lastName}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateField('lastName', e.target.value)}
        />
      </div>

      <div style={{ marginTop: '16px' }}>
        <Input
          name="title"
          label="TITLE"
          value={data.title}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateField('title', e.target.value)}
        />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '32px', marginTop: '16px' }}>
        <Input
          name="phone"
          label="PHONE NUMBER"
          value={data.phone}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateField('phone', e.target.value)}
        />
        <Input
          name="email"
          label="EMAIL ADDRESS"
          value={data.email}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateField('email', e.target.value)}
        />
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '24px' }}>
        <button
          type="button"
          onClick={onBack}
          style={{
            width: '167px',
            height: '35px',
            backgroundColor: 'var(--color-disabled)',
            color: 'white',
            borderRadius: '999px',
            border: 'none',
            fontSize: '0.75rem',
            fontWeight: 600,
            letterSpacing: '1.4px',
            cursor: 'pointer'
          }}
        >
          BACK
        </button>
        <button
          type="button"
          onClick={onSubmit}
          style={{
            width: '167px',
            height: '35px',
            backgroundColor: 'var(--color-accent)',
            color: 'white',
            borderRadius: '999px',
            border: 'none',
            fontSize: '0.75rem',
            fontWeight: 600,
            letterSpacing: '1.4px',
            cursor: 'pointer'
          }}
        >
          SUBMIT
        </button>
      </div>
    </div>
  );
};

export default BrandContactStep;
